<template>
<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
    <div class="box-layout">
        <div class="tabbed-selection booking-tabs" v-if="current.length > 0 || expired.length > 0 || cancelled.length > 0">

			<div class="tabs-controller">
				<transition-group name="list">
					<a class="tab ignore col-xs-12 col-sm-4 col-md-4 col-lg-4" :class="{'active':tab=='current'}" @click="tab='current'" key="currentBookings">
						{{ locale.text_tab_future_bookings }}
					</a>
					<a class="tab ignore col-xs-12 col-sm-4 col-md-4 col-lg-4" :class="{'active':tab=='expired'}" @click="tab='expired'" key="expiredBookings">
                        {{ locale.text_tab_expired_bookings }}
					</a>
                    <a class="tab ignore col-xs-12 col-sm-4 col-md-4 col-lg-4" :class="{'active':tab=='cancelled'}" @click="tab='cancelled'" key="cancelledBookings">
                        {{ locale.text_tab_cancelled_bookings }}
                    </a>
				</transition-group>
			</div>

            <div class="tabbed-panels account-panels">
                    <transition name="slide-fade">

                        <div class="panel-inner" key="select-current" v-if="tab == 'current'">
                            <div v-for="collection in current" v-if="collection != undefined">
                                <div class="box-layout-inner">
                                    <div class="title-block">
                                        <div class="col-md-12" v-html="collection.venue_name"></div>
                                    </div>
                                    <ul class="content-links">
                                        <li v-for="item in collection.items" :data-booking="item.booking_id" :data-item="item.id">
                                            <router-link :to="{ name: 'account.bookings.view', params: { bookingId: item.booking_id } }">
                                                <span class="col-lg-7 col-md-7 col-sm-6 col-xs-12" v-html="'<i class=\'fa fa-calendar\'></i>' + (new Date(item.start_date)).formatRange(item.days_attending)"></span>
                                                <span class="col-lg-2 col-md-2 col-sm-2 col-xs-12" v-html="'('+item.booking_state_readable+')'"></span>
                                                <span class="col-lg-3 col-md-3 col-sm-4 col-xs-12">
                                                    <span v-html="item.participant_full_name"></span>
                                                </span>

                                                <button class="btn btn-primary rebook-button" v-on:click.stop.prevent="rebook(item)">
                                                    Rebook
                                                </button>
                                            </router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div v-if="current.length == 0">
                                <div class="box-layout-inner">
                                    <div class="title-block">
                                        <p class="text-center">{{ locale.text_tab_bookings_empty }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="panel-inner" key="select-expired" v-else-if="tab == 'expired'">
                            <div v-for="collection in expired" v-if="collection != undefined">
                                <div class="box-layout-inner">
                                    <div class="title-block">
                                        <div class="col-md-12" v-html="collection.venue_name"></div>
                                    </div>
                                    <ul class="content-links">
                                        <li v-for="item in collection.items" :data-booking="item.booking_id" :data-item="item.id">
                                            <router-link :to="{ name: 'account.bookings.view', params: { bookingId: item.booking_id } }">
                                                <span class="col-lg-7 col-md-7 col-sm-6 col-xs-12" v-html="'<i class=\'fa fa-calendar\'></i>' + (new Date(item.start_date)).formatRange(item.days_attending)"></span>
                                                <span class="col-lg-2 col-md-2 col-sm-2 col-xs-12" v-html="'('+item.booking_state_readable+')'"></span>
                                                <span class="col-lg-3 col-md-3 col-sm-4 col-xs-12">
                                                    <span v-html="item.participant_full_name"></span>
                                                </span>
                                            </router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div v-if="expired.length == 0">
                                <div class="box-layout-inner">
                                    <div class="title-block">
                                        <p class="text-center">{{ locale.text_tab_bookings_empty }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="panel-inner" key="select-cancelled" v-else-if="tab == 'cancelled'">
                            <div v-for="collection in cancelled" v-if="collection != undefined">
                                <div class="box-layout-inner">
                                    <div class="title-block">
                                        <div class="col-md-12" v-html="collection.venue_name"></div>
                                    </div>
                                    <ul class="content-links">
                                        <li class="cancelled-booking" v-for="item in collection.items" :data-booking="item.booking_id" :data-item="item.id">
                                            <router-link :to="{ name: 'account.bookings.view', params: { bookingId: item.booking_id } }">
                                                <span class="col-lg-7 col-md-7 col-sm-6 col-xs-12" v-html="'<i class=\'fa fa-calendar\'></i>' + (new Date(item.start_date)).formatRange(item.days_attending)"></span>
                                                <span class="col-lg-2 col-md-2 col-sm-2 col-xs-12" v-html="'('+item.booking_state_readable+')'"></span>
                                                <span class="col-lg-3 col-md-3 col-sm-4 col-xs-12">
                                                    <span v-html="item.participant_full_name"></span>
                                                </span>
                                            </router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div v-if="cancelled.length == 0">
                                <div class="box-layout-inner">
                                    <div class="title-block">
                                        <p class="text-center">{{ locale.text_tab_bookings_empty }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition>
            </div>


        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" v-else-if="loading">
            <p class="text-center"><i class="fa fa-spinner fa-pulse fa-5x dark"></i></p>
        </div>
    </div>
</div>
</template>

<script>
    export default {
        data () {
            return {
                loading: true,

                current: {},
                expired: {},
                cancelled: {},
                tab: 'current'
            }
        },
        computed: {
            locale: function () {
                return this.$root.locale.account.bookings;
            }
        },
        methods: {
            rebook: function (item) {
                this.$router.push({
                    name: 'booking.quickadd',
                    params: {
                        venueId: item.venue_id,
                        childId: item.participant_id
                    }
                })
            }
        },
        created () {

            /**Checking if the user is currently logged in**/
            axios.get('/camp-booking/users/current')
                .then(response => {
                    if(response.data.data.user_id == null) {
                        this.$router.push({name: 'auth.login'});
                        return false;
                    }
                })

            /** Retrieving the current users bookings **/
            axios.get('/camp-booking/users/' + this.$root.auth.user_id + '/booking-items?hide_created=true')
                .then(response => {
                    var items = response.data.data;
                    if(items.length == 0) {
                        this.loading = false;
                        this.$root.alert(this.locale.text_tab_bookings_empty, 'danger', false, true, true);
                        return false;
                    }
                    var collection = {current: [], expired: [], cancelled: []};

                    items.forEach(item => {

                        let date = new Date(item.start_date);
                        let endDate = new Date(item.end_date);
                        let section = (item.booking_item_state_id == 4 ? 'cancelled' : (endDate.getTime() >= Date.now() ? 'current' : 'expired'));

                        /** Checking if the booking is cancelled, if so then don't add it **/
//                        if(item.booking_item_state_id == 4)
//                            return false;

                        /** If the month doesn't already exist, create a new item in the array **/
                        if(!collection[section][date.getMonth()])
                            collection[section][date.getMonth()] = {month: date.getStrMonth('long'), items: []};

                        /** Adding the item to the correct month **/
                        collection[section][date.getMonth()].items.push(item);
                        if(section == 'expired')
                            collection[section][date.getMonth()].items.sort(function(a,b) { return (a.start_date <= b.start_date) ? ((a.participant_full_name.toLowerCase() > b.participant_full_name.toLowerCase()) ? 1 : -1) : ((b.participant_full_name.toLowerCase() > a.participant_full_name.toLowerCase()) ? -1 : 0);});
                        else
                            collection[section][date.getMonth()].items.sort(function(a,b) { return (a.start_date >= b.start_date) ? ((a.participant_full_name.toLowerCase() > b.participant_full_name.toLowerCase()) ? 1 : -1) : ((b.participant_full_name.toLowerCase() > a.participant_full_name.toLowerCase()) ? -1 : 0);});
                    })
                    this.current = [];
                    collection.current.forEach(col => {
                        col.items.forEach(item => {
                            let date = item.start_date.toDate();
                            let key = item.venue_id;
                            if(!this.current.hasOwnProperty(key))
                                this.current[key] = { venue_name: item.venue_name + ' (' + item.venue_town +')', month: date.getStrMonth('long'), items: []};
                            this.current[key].items.push(item);

                            //Ordering the results by date
                            this.current[key].items.sort(function(a,b){
                                // Turn your strings into dates, and then subtract them
                                // to get a value that is either negative, positive, or zero.
                                return new Date(a.start_date) - new Date(b.start_date);
                            });
                        });

                        // console.log('current: ', this.current);
                    })
                    this.expired = [];
                    collection.expired.forEach(col => {
                        col.items.forEach(item => {
                            let date = item.start_date.toDate();
                            let key = item.venue_id;
                            if(!this.expired.hasOwnProperty(key))
                                this.expired[key] = { venue_name: item.venue_name + ' (' + item.venue_town +')', month: date.getStrMonth('long'), items: []};
                            this.expired[key].items.push(item);

                            //Ordering the results by date
                            this.expired[key].items.sort(function(a,b){
                                // Turn your strings into dates, and then subtract them
                                // to get a value that is either negative, positive, or zero.
                                return new Date(a.start_date) - new Date(b.start_date);
                            });
                        });
                    })
                    this.cancelled = [];
                    collection.cancelled.forEach(col => {
                        col.items.forEach(item => {
                            let date = item.start_date.toDate();
                            let key = item.venue_id;
                            if(!this.cancelled.hasOwnProperty(key))
                                this.cancelled[key] = { venue_name: item.venue_name + ' (' + item.venue_town +')', month: date.getStrMonth('long'), items: []};
                            this.cancelled[key].items.push(item);

                            //Ordering the results by date
                            this.cancelled[key].items.sort(function(a,b){
                                // Turn your strings into dates, and then subtract them
                                // to get a value that is either negative, positive, or zero.
                                return new Date(a.start_date) - new Date(b.start_date);
                            });
                        });
                    })

                    this.loading = false;
                });

            /**
             * Setting the headers
             */
            this.$root.headers = {
                navigate: {
                    name: 'account.overview'
                },
                title: this.$root.locale.miscellaneous.page_headings.account.view_all_bookings
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Bookings.vue?8acf0fa2